export { default } from './withMobileDialog';


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/core/esm/withMobileDialog/index.js
// module id = 875
// module chunks = 2